<h1 mat-dialog-title class="no-margin">
  {{title}}
  <mat-icon class="close-icon" (click)="onClose()">close</mat-icon>
</h1>

<div style="font-size: 18px; padding : 25px;" class="warn">
  <p>
    {{message}}
  </p>
</div>

<div mat-dialog-actions class="actions">
  <button mat-fab extended class="searchbox-buttons save-button" (click)="onClose()">
    <mat-icon>check</mat-icon>
    Ok
  </button>
</div>
